var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userIsActivated
    ? _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _c("h2", [_vm._v("Booking Agents")]),
          _vm._v(" "),
          _c("profile-manager-staff-form"),
          _vm._v(" "),
          _c("div", { staticClass: "margin-20" }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "item-detail item-detail-simple" },
            _vm._l(_vm.staffUsers, function (staffUser) {
              return _c("profile-manager-staff-list-item", {
                key: staffUser.id,
                attrs: { "staff-user": staffUser },
              })
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }